export const languageMap = new Map([
  ['en', { label: 'English', dir: 'ltr', active: true }],
  ['es', { label: 'Español', dir: 'ltr', active: false }]
  // ['es-419', { label: 'Español en américa latina', dir: 'ltr', active: false }],
  // ['es-CR', { label: 'Español en Costa Rica', dir: 'ltr', active: false }],
  // ['fr', { label: 'French', dir: 'ltr', active: false }]
  // ['pl', { label: 'Polski', dir: 'ltr', active: false }],
  // ['ppl', { label: 'Polski', dir: 'ltr', active: false }],
]);
